module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAZAAA/+4ADkFkb2JlAGTAAAAAAf/bAIQAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQICAgICAgICAgICAwMDAwMDAwMDAwEBAQEBAQECAQECAgIBAgIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMD/8AAEQgAEAADAwERAAIRAQMRAf/EAGUAAQAAAAAAAAAAAAAAAAAAAAkBAQAAAAAAAAAAAAAAAAAAAAgQAAAEBAcAAAAAAAAAAAAAAAARMVHwAUFhBAZW1gcXVxEAAQAKAwAAAAAAAAAAAAAAAPARMXGh0gOjNAZUFhf/2gAMAwEAAhEDEQA/AGt7I4L9hwCaHz/t1QVu/wCjqz7FeRHBQ9E0fn2K8kWBuFO7pQiYocF4K5//2Q=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/title_icon.jpg
// module id = LFPh
// module chunks = 1